import { render, staticRenderFns } from "./TopInfluencersCard.vue?vue&type=template&id=4675dd1f&"
import script from "./TopInfluencersCard.vue?vue&type=script&lang=js&"
export * from "./TopInfluencersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports